import '.e{display:flex;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.co{gap:48px;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.do{padding-top:20px;}.ssr-plugin'
import '.dp{padding-bottom:8px;}.ssr-plugin'
import '.dq{min-height:240px;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.dr{backdrop-filter:blur(8px);}.ssr-plugin'
import '.ds{-webkit-backdrop-filter:blur(8px);}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.dt{font-family:Singing-Sans;}.ssr-plugin'
import '.du{font-size:clamp(100px, 10vw, 144px);}.ssr-plugin'
import '.de{display:block;}.ssr-plugin'
import '.dv{animation:esc-slide-out 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards;}.ssr-plugin'
import '.d7{word-break:break-word;}.ssr-plugin'
import '.dw{font-size:18px;}.ssr-plugin'
import '.dx{font-weight:900;}.ssr-plugin'
import '.dy{letter-spacing:0rem;}.ssr-plugin'
import { useState, useEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { MOBILE, TABLET } from '../utils/breakpoints.js'
import { useDictionary } from '../hooks/useDictionary.js'

type CountdownTimerProps = {
  targetTimestamp: number
  dictionary?: any
  style?: Style
}

const formatTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const pad = (n: number) => String(n).padStart(2, '0')
  return {
    Tdays: pad(days),
    Thours: pad(hours),
    Tminutes: pad(minutes),
    Tseconds: pad(seconds),
  }
}

export const CountdownTimer = ({
  targetTimestamp,
  style,
}: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const remaining = targetTimestamp - Date.now()
    return remaining > 0 ? remaining : 0
  })

  const { days, hours, minutes, seconds } = useDictionary()

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = targetTimestamp - Date.now()
      if (remaining <= 0) {
        setTimeLeft(0)
        clearInterval(interval)
      } else {
        setTimeLeft(remaining)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [targetTimestamp])

  const { Tdays, Thours, Tminutes, Tseconds } = formatTime(timeLeft)

  return (
    <styled.div className="e m co"
      style={{
        [TABLET]: { gap: '24px' },
        [MOBILE]: {
          gap: '8px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
        },
        ...style,
      }}
    >
      <CountdownTimerElement numbers={Tdays} description={days} />
      <CountdownTimerElement numbers={Thours} description={hours} />
      <CountdownTimerElement numbers={Tminutes} description={minutes} />
      <CountdownTimerElement numbers={Tseconds} description={seconds} />
    </styled.div>
  )
}

type CountdownTimerElementProps = {
  numbers: string
  description: string | any
}

const CountdownTimerElement = ({
  numbers,
  description,
}: CountdownTimerElementProps) => {
  const prevRef = useRef({
    current: numbers,
    exiting: null as string | null,
    key: 0,
  })
  const [, setTick] = useState(0)

  const key =
    prevRef.current.current !== numbers
      ? prevRef.current.key + 1
      : prevRef.current.key

  const state = {
    current: numbers,
    exiting:
      prevRef.current.current !== numbers ? prevRef.current.current : null,
    key,
  }

  prevRef.current = { current: numbers, exiting: state.exiting, key }

  return (
    <div className="b5 m h"
    >
      <styled.div className="ai e w cy c2 bn do dp dq cx m b1 dr ds"
        style={{
          border: `1px solid ${colors.border}`,
          background: `linear-gradient(180deg, ${transparentColor(colors.white, 0)} 0%, ${transparentColor(colors.white, 0.1)} 50%, ${transparentColor(colors.white, 0)} 100%)`,
          [TABLET]: {
            minHeight: '96px',
          },
          [MOBILE]: {
            marginBottom: '8px',
          },
        }}
      >
        <style>{`
          @keyframes esc-slide-out {
            from { transform: translateY(0%);    opacity: 1; }
            to   { transform: translateY(-70%);  opacity: 0; }
          }
          @keyframes esc-slide-in {
            from { transform: translateY(70%);   opacity: 0; }
            to   { transform: translateY(0%);    opacity: 1; }
          }
        `}</style>
        {state.exiting !== null && (
          <styled.span className="a6 dt du de dv"
            key={`exit-${state.key}`}
            onAnimationEnd={() => {
              prevRef.current.exiting = null
              setTick((t) => t + 1)
            }}
            style={{
              color: colors.primary,
              [TABLET]: {
                fontSize: 'clamp(36px, 20vw, 72px)',
              },
              [MOBILE]: {
                fontSize: 'clamp(24px, 14vw, 64px)',
              },
            }}
          >
            {state.exiting}
          </styled.span>
        )}
        <styled.span className="dt du de"
          key={`enter-${state.key}`}
          style={{
            color: colors.primary,
            animation:
              state.key > 0
                ? 'esc-slide-in 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards'
                : 'none',
            [TABLET]: {
              fontSize: 'clamp(36px, 20vw, 72px)',
            },
            [MOBILE]: {
              fontSize: 'clamp(24px, 14vw, 64px)',
            },
          }}
        >
          {state.current}
        </styled.span>
      </styled.div>
      <styled.p className="d7 m dw dx dt dy"
        style={{
          [MOBILE]: {
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'Neulis-Regular',
          },
        }}
      >
        {description}
      </styled.p>
    </div>
  )
}
